export const GET_STATUS_OPTIONS = 'get_status_options';
export const GET_STATUS_OPTIONS_FAILED = 'get_status_options_failed';
export const GET_FORMS_TODO_LIST = 'constant_state_get_forms_todo_list';
export const SET_FORMS_TODO_LIST = 'constant_state_set_forms_todo_list';
